import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log('initImagesForm');

    function readURL(input: HTMLInputElement) {
      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = function (e) {
          const result = e.target?.result;
          if (typeof result === "string") {
            $(input).next().attr("src", result);
          }
        };
        reader.readAsDataURL(input.files[0]);
      }
    }
    $(".image_attributes_uri").on("change", (e) => {
      const input = e.currentTarget as HTMLInputElement;
      readURL(input);
    });
    $('#images').on('cocoon:before-insert', (e, image) => {
      image.find(".image_attributes_uri").on("change", (e2: any) => {
        const input = e2.currentTarget as HTMLInputElement;
        readURL(input);
      });
      $(image).css('display', 'none');
      $(image).css('width', '200px');
      $(image).css('height', '200px');
      $(image).show('slow', function () {
        $(image).css('width', 'auto');
        $(image).css('height', 'auto');
      });
      image.find('.image_attributes_uri').click();
    }).on('cocoon:before-remove', function (e, image) {
      $(this).data('remove-timeout', 1000);
      image.hide('slow');
    });
  }
}